import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import EmployeeTable from './EmployeeTable';
import { getAllEmployeesInitiate } from '../../../actions/employee';
import { currentFlowTypeEnum } from '../../common/components/constants';

const mapStateToProps = state => {
  const employeesData = _get(state, 'employees', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    viewOnlyMode,
    employeesData,
    selectedWorkspace,
    fetchingEmployees:
      _get(state, 'apiState.GET_EMPLOYEES.isFetching', true) &&
      !_get(state, 'apiState.GET_EMPLOYEES.isIdle', false),
    fetchedEmployees: _get(state, 'apiState.GET_EMPLOYEES.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  getAllEmployees: payload => dispatch(getAllEmployeesInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmployeeTable);
